import { render, staticRenderFns } from "./BrbSelect.vue?vue&type=template&id=8e164a80&"
import script from "./BrbSelect.vue?vue&type=script&lang=js&"
export * from "./BrbSelect.vue?vue&type=script&lang=js&"
import style0 from "./BrbSelect.vue?vue&type=style&index=0&id=8e164a80&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/matin/baarbaanet/frontend/admin-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e164a80')) {
      api.createRecord('8e164a80', component.options)
    } else {
      api.reload('8e164a80', component.options)
    }
    module.hot.accept("./BrbSelect.vue?vue&type=template&id=8e164a80&", function () {
      api.rerender('8e164a80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/brb-components/BrbSelect.vue"
export default component.exports